export default "__VITE_ASSET__BwFIzijm__"